import * as actions from './quizzes.actions'

const initialState = {
  saveOk: false,
  saveError: false,
  question: null,
  voteQuestion: null,
  loading: false,
  search: null,
  disputesList: [],
  questionsList: {
    created: [],
    debated: [],
    disputed: [],
  },
  disputesListFilter: 'disputed',
  feedBack: {
    answerId: undefined,
    correct: undefined,
    coins: undefined,
  },
}

const actionsMap = {
  [actions.ANSWER_QUESTION]: (state) => ({
    ...state,
    loading: true,
  }),
  [actions.SAVE_QUESTION_OK]: (state) => {
    return {
      ...state,
      saveOk: true,
      loading: false,
    }
  },
  [actions.SAVE_QUESTION_ERROR]: (state, action) => {
    const error = action.data
    return {
      ...state,
      saveError: error,
      loading: false,
    }
  },
  [actions.SET_QUESTION]: (state, action) => {
    const question = action.data

    return {
      ...state,
      question: question,
      loading: true,
    }
  },
  [actions.SET_QUESTIONS_LIST]: (state, action) => {
    const data = action.data
    let questionsList = {
      created: data.createdQuestions,
      debated: data.debatedQuestions,
      disputed: data.disputedQuestions,
      answers: data.answerList,
    }
    return {
      ...state,
      questionsList,
    }
  },
  [actions.SET_DISPUTE_LIST]: (state, action) => {
    const data = action.data
    return {
      ...state,
      disputesList: data,
    }
  },
  [actions.SET_VOTE_QUESTION]: (state, action) => {
    const voteQuestion = action.data
    return {
      ...state,
      voteQuestion: voteQuestion,
    }
  },
  [actions.CLEAR_RESPONSES]: (state) => {
    return {
      ...state,
      saveOk: false,
      saveError: false,
      question: null,
    }
  },
  [actions.SET_FEEDBACK]: (state, action) => {
    const { answerId, correct, coins } = action.data
    return {
      ...state,
      feedBack: {
        answerId,
        correct,
        coins,
      },
    }
  },
  [actions.GET_DISPUTES_SUCCESS]: (state, action) => {
    const data = action.data
    return {
      ...state,
      disputesList: data,
    }
  },
  [actions.CHANGE_FILTER]: (state, action) => {
    const filter = action.data

    return {
      ...state,
      disputesListFilter: filter,
    }
  },
  [actions.SEARCH_QUESTION]: (state, action) => {
    const search = action.data

    return {
      ...state,
      search: search,
    }
  },
  [actions.CLEAR_FEEDBACK]: (state) => ({
    ...state,
    feedBack: initialState.feedBack,
  }),
  [actions.CREATE_QUESTION]: (state) => ({
    ...state,
    loading: true,
  }),
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
